import React, { Component } from 'react';
import { Redirect, Router, Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import history from '../../history';
import routes from '../../utils/routes';
import CredentialsHelper from '../../utils/credentials-helper';
import InternalPagesContainer from '../internal-pages/internal-pages';
import Loader from '../commons/loader/loader';
import LoginRedirect from '../commons/login-redirect';
import { convertCode } from './app.actions';
import SCISRedirection from '../SCISRedirection';

import './app.css';

export default class App extends React.Component {

    render() {
        return (
            <Router history={history}>
                <Switch>
                    <Route path={routes.SCIS_REDIRECTION} component={SCISRedirection}/>
                    <Root exact path={routes.ROOT}/>
                    <InternalPagesContainer {...this.props} history={history}/>
                </Switch>
            </Router>
        );
    }
}

class _Root extends Component {
    componentDidMount() {
        const code = new URLSearchParams(this.props.location.search).get('code');
        if (code) {
            this.props.convertCode(code);
        }
    }

    render() {
        if (CredentialsHelper.isLoggedIn) {
            return <Redirect to={routes.HOME}/>;
        }
        if (new URLSearchParams(this.props.location.search).get('code')) {
            return <Loader/>;
        }
        return <LoginRedirect/>;
    }
}

const Root = connect(null, dispatch => bindActionCreators({ convertCode }, dispatch))(_Root);



// WEBPACK FOOTER //
// ./src/components/app/app.js